<template>
  <div id="million-bit-demo">
      <div id="close-demo" @click.prevent="close()">
        <button class="btn btn-primary">Back</button>
      </div>
      <video src="/static/mobile-demo-pfp.webm" autoplay controls></video>
    </div>
  </template>
  
  <script>
  export default {
    name: 'nav-demo',
    data () {
      return {
      }
    },
    inject: ['updateAppRoute', 'appData', 'postToLambda'],
    created: function () {
      this.updateAppRoute('demo');
    },
    methods: {
      close: function () {
        this.$router.push('/');
      }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  #close-demo {
      position: absolute;
      top: 10px;
      left: 0;
      padding: 10px;
      z-index: 1001;
  }
    #million-bit-demo {
      display: block;
      position: fixed;
      margin: 0 auto;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1000;
      background: white;
    }
    #million-bit-demo video {
      height: 100%;
      max-width: 100%;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/Demo.vue?75dd0ff0